module.exports = [{
      plugin: require('/home/travis/build/kitos/kitos.github.io/node_modules/gatsby-plugin-netlify-cms/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/home/travis/build/kitos/kitos.github.io/node_modules/gatsby-plugin-layout/gatsby-browser.js'),
      options: {"plugins":[],"component":"/home/travis/build/kitos/kitos.github.io/src/components/layout.js"},
    },{
      plugin: require('/home/travis/build/kitos/kitos.github.io/node_modules/gatsby-remark-images/gatsby-browser.js'),
      options: {"plugins":[],"withWebp":true,"maxWidth":590},
    },{
      plugin: require('/home/travis/build/kitos/kitos.github.io/node_modules/gatsby-plugin-typography/gatsby-browser.js'),
      options: {"plugins":[],"pathToConfigModule":"src/utils/typography"},
    },{
      plugin: require('/home/travis/build/kitos/kitos.github.io/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-112745683-4"},
    },{
      plugin: require('/home/travis/build/kitos/kitos.github.io/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
